<template>
	<div class="customerWallet">
		
		<b-container fluid class="p-0 mt-2">
			<b-card >
			<b-row class="mb-3 mt-3">
				
                <b-col>
					<h6><div class="walletIcon"><b-icon class="ml-1 walletFont" icon="wallet2" aria-hidden="true"></b-icon></div><div class="welletText"><span class="heading">Alluraa Wallet</span><br/><small>Your purse to shop on Alluraa</small></div></h6>
					
                    <!-- <p>Hello {{$root.customer_info.custname}} (not {{$root.customer_info.custname}}? <b-link href="/customer/logout">Log out</b-link> )</p>
                    <p>Fromt your account dashboard you can view your recent orders, manage your shipping and billing addresses and edit your password and account details.</p> -->
                </b-col>
			</b-row>
			
			<b-row class="mt-5">
				
                <b-col>
				<ul>
					<li>Wallet Balance</li>
					<li class="amountTextColor">{{$root.currency()+$root.tofixed(total_blance, 2)}}</li>
				</ul>
					
                </b-col> 
				
               
			</b-row>
			<b-row class="mt-2 walletHistory">
				
                <b-col class="p-0">
				<ul>
					<li><b-row class="walletAc">
					<b-col cols="12" lg="4" md="12" sm="12">REWARD / BONUS</b-col>
					<b-col cols="8" lg="5" md="8" sm="8" >{{$root.currency()+$root.tofixed(blance, 2)}} <small style="color:#e60381;" v-if="blance>0">({{'Expires On '+endTime}})</small> 
					<!--<b-link v-else  class="hlink">NO HISTORY</b-link>-->
					
					</b-col>
					<b-col cols="4" lg="3" md="4" sm="4"><b-link  :href="'/'+historyPreUrl+'/wallet/transactionHistory'" class="hlink">HISTORY</b-link> </b-col>
					</b-row></li>
					
					<li><b-row class="walletAc">
					<b-col cols="12" lg="4" md="12" sm="12">CASHBACK </b-col>
					<b-col cols="8" lg="5" md="8" sm="8" >{{$root.currency()+$root.tofixed(blance_cb, 2)}} &nbsp; &nbsp; 
					<b-link class="ml-2" v-b-popover.hover.top.html="popoverMethod" title="Know More…">
					<i class="fa fa-info-circle" aria-hidden="true"  ></i> </b-link>
					
					<!--<b-link v-else  class="hlink">NO HISTORY</b-link>-->
					
					</b-col>
					<b-col cols="4" lg="3" md="4" sm="4"><b-link  :href="'/'+historyPreUrl+'/wallet/transactionHistory'" class="hlink">HISTORY</b-link> </b-col>
					</b-row></li>
					
					
					<!-- <li>
					
					<b-row class="walletAp"><b-col> REWARD POINTS</b-col><b-col>{{$root.currency()+$root.tofixed(blance, 2)}} <b-link  :href="'/'+historyPreUrl+'/wallet/transactionHistory'" class="hlink">HISTORY</b-link>
					
					</b-col></b-row>
					</li>  -->
				</ul>
					
                </b-col>
			</b-row>
			</b-card>
		</b-container>
		
		
		
		<!-- <quickview :modaldata="$root.quickview_data"></quickview> -->
	</div>
</template>
<script>

export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {

	//props: ["time"],
	//template: '<div class="col-sm">  <div class="card text-center">    <div class="card-block">      <h4 class="card-title">{{time.time}}</h4>    </div>    <div class="card-footer">      {{time.text}}    </div>  </div></div>'

       
	},
	created:{
    
  },
	mounted(){
        this.initload();
		var userRoll = this.$root.customer_info.role;
		if(userRoll==4){
		this.historyPreUrl='customer';
		}else if(userRoll==2){
		
		this.historyPreUrl='seller';
		}else if(userRoll==3){		
		this.historyPreUrl='agent';
		}else if(userRoll==1){
		
		this.historyPreUrl='admin';
		}else{
		this.historyPreUrl='';
		}
		
		//this.updateTimer();
		//this.timeinterval = setInterval(this.updateTimer, 1000);
	},
	data() {
		return{
			statusSidebar: false,
            modal_data: {
                price: 0,
                special_price: 0
			},
			slide:0,
			historyPreUrl:'',
			walletRecord: [],
			blance: 0,
			cr_amount: 0,
			dr_amount: 0,
			crdate: '',
			expiresdate:'',
			cr_amount_cb:0,
			dr_amount_cb:0,
			blance_cb:0,
			total_blance:0,
			//url: this.$root.WEBURL+'customer-orders',
			recordUrl: this.$root.WEBAPI+'walletapi/mywallet-record',
			startTime: '', //"July 7, 2017 12:03:00",
			endTime: '', //"July 26, 2021 14:55:00",
			times: [
			  { id: 0, text: "Days", time: 1 },
			  { id: 1, text: "Hours", time: 1 },
			  { id: 2, text: "Minutes", time: 1 },
			  { id: 3, text: "Seconds", time: 1 }
			],
			progress: 100,
			// isActive: false,
			timeinterval: undefined,
		};
	},
	methods: {
		burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.recordUrl, {
                accesskey: self.$session.get('access_key'),
                roleId: self.$root.customer_info.role,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.walletRecord 	= response.data.result;
					self.blance			= response.data.result.blance;
					self.cr_amount		= response.data.result.cr_amount;
					self.dr_amount		= response.data.result.dr_amount;
					self.crdate			= response.data.result.crdate;
					self.expiresdate	= response.data.result.expiresdate;
					
					self.cr_amount_cb	= response.data.result.cr_amount_cb;
					self.dr_amount_cb	= response.data.result.dr_amount_cb;
					self.blance_cb		= response.data.result.blance_cb;
					self.total_blance	= response.data.result.total_blance;
					
					//'July 7, 2017 12:03:00'
					
                   
					
					var startDateNew =  self.$moment(self.crdate).format('DD.MM.YYYY');
					var new_date = self.$moment(startDateNew, "DD-MM-YYYY").add(7, 'days');
					self.startTime = self.$moment(self.crdate).format('MMMM D, YYYY h:mm:ss');
					self.endTime = self.$moment(new_date).format('DD-MM-YYYY');
					console.log('startTime:'+self.startTime);
					console.log('endTime:'+self.endTime);
                    //console.log(self.share_data);
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		popoverMethod(){
			 return '<ul class="p-0"><li>• 100% cashback applicable on cash orders only</li><li>• Cashback credited immediately but can be used after order is delivered & there is no return</li><li>•	Only 50% can be redeemed at one time</li></ul>';
		},
		
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
.col-form-label-sm{
padding:0px;
margin:0px;}
.customerWallet{
	.walletIcon{
		float:left;
		width: 7%;
		.walletFont{
			font-size:50px;
			color:#a437e9;
		}
	}
	.welletText{
			width: 93%;
		.heading{ font-size:23px;}
	}
	.amountTextColor{ color:#a437e9; } 
	
	.walletHistory{
	width: 52%;
    font-size: 14px;
		
		.walletAc{border-top: 1px solid #c6c6c6;
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.walletAp{
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.hlink{
		margin-left:10px;
		color:#a437e9;
		}
	}

}





</style>